import { DataColumn } from "@/components/layout/input/inputType";
import { Debug } from "./debug";

export function getIntArray(lenght: number, start?: number, run?: (i: number, length: number) => void) {
  return Array.from({ length: lenght }, (_, i) => {
    const now_i = (start ?? 0) + i;
    if (run) {
      run(now_i, length);
    }
    return now_i;
  });
}
export function arrPickObj<T>(arr: T | T[] | undefined, i?: number) {
  if (arr === undefined) {
    return undefined;
  } else if (arr instanceof Array) {
    const ai = i ?? 0;
    if (ai < 0) {
      if (arr.length > 0) {
        return arr[arr.length - 1];
      } else {
        return undefined;
      }
    } else if (arr.length > ai) {
      return arr[ai];
    } else if (arr.length > 0) {
      return arr[0];
    } else {
      return undefined;
    }
  } else {
    return arr;
  }
}
export function getStringArr(keys: string | string[] | Record<string, string>): string[] {
  return keys instanceof Array || keys === undefined ? keys : typeof keys === "string" ? [keys] : Object.keys(keys);
}
export function getStringLabel(key: string, keys?: string | string[] | Record<string, string>) {
  return keys instanceof Array || typeof keys == "string" ? key : keys ? (keys[key] ?? key) : key;
}
export function getStringRecord(keys: string | string[] | Record<string, string>): Record<string, string> {
  const result: Record<string, string> = {};
  if (keys instanceof Array) {
    keys.map((key) => {
      result[key] = key;
    });
  } else if (typeof keys == "string") {
    result[keys] = keys;
  } else {
    return keys;
  }
  return result;
}

export function mergeArr(...args: (any[] | undefined)[]) {
  const result: any[] = [];
  args.forEach((item) => {
    if (item) {
      item.forEach((obj) => {
        if (!result.includes(obj)) {
          result.push(obj);
        }
      });
    }
  });
  if (result.length > 0) {
    return result;
  } else {
    return undefined;
  }
}

const CHOSUNG_REGEX = /ㄱ|ㄲ|ㄴ|ㄷ|ㄸ|ㄹ|ㅁ|ㅂ|ㅃ|ㅅ|ㅆ|ㅇ|ㅈ|ㅉ|ㅊ|ㅋ|ㅌ|ㅍ|ㅎ/g;
const CHOSUNG_MAP: Record<string, string> = {
  ㄱ: "[가-깋]",
  ㄲ: "[까-낗]",
  ㄴ: "[나-닣]",
  ㄷ: "[다-딯]",
  ㄸ: "[따-띻]",
  ㄹ: "[라-맇]",
  ㅁ: "[마-밓]",
  ㅂ: "[바-빟]",
  ㅃ: "[빠-삫]",
  ㅅ: "[사-싷]",
  ㅆ: "[싸-앃]",
  ㅇ: "[아-잏]",
  ㅈ: "[자-짛]",
  ㅉ: "[짜-찧]",
  ㅊ: "[차-칳]",
  ㅋ: "[카-킿]",
  ㅌ: "[타-팋]",
  ㅍ: "[파-핗]",
  ㅎ: "[하-힣]",
};
export function getKRFirstRegExp(keyword?: string) {
  if (keyword) {
    let change_keyword = keyword;
    const match = keyword.match(CHOSUNG_REGEX);
    if (match) {
      match.forEach((str) => {
        if (str && CHOSUNG_MAP[str]) {
          change_keyword = change_keyword.replace(str, CHOSUNG_MAP[str]);
        }
      });
      return new RegExp(change_keyword, "g");
    } else {
      return undefined;
    }
  }
}

export const equals = (a: any, b: any) => a.length === b.length && a.every((v: any, i: any) => v === b[i]);
export const objEquals = (org_value: any, check_value: any) => {
  let change = false;
  if (org_value !== undefined && check_value !== undefined && org_value !== null && check_value !== null) {
    if (check_value instanceof Array) {
      if (!equals(check_value, org_value)) {
        change = true;
      }
    } else if (check_value !== org_value) {
      change = true;
    }
  } else if ((org_value === undefined && check_value === undefined) || (org_value === null && check_value === null)) {
  } else {
    if (
      (org_value === undefined || org_value === null || org_value === "") &&
      (check_value === undefined || check_value === null || check_value === "")
    ) {
    } else {
      change = true;
    }
  }
  return change;
};
export const sortDataColumn = (a: DataColumn, b: DataColumn) => {
  return a.order === undefined && b.order === undefined
    ? 0
    : a.order !== undefined && b.order !== undefined
      ? a.order < b.order
        ? -1
        : 0
      : a.order !== undefined
        ? -1
        : 1;
};

export function getTranslate(g: SVGGElement) {
  const transform = g.getAttribute("transform");
  const match = transform?.match(/translate\(([-\d.]+)[,\s]*([-\d.]+)\)/);
  if (match) {
    return {
      x: parseFloat(match[1]),
      y: parseFloat(match[2]),
    };
  }
  return null;
}
export function getTranslateWithCTM(g: SVGGElement) {
  const ctm = g.getCTM();
  if (ctm) {
    return {
      x: ctm.e,
      y: ctm.f,
    };
  }
  return null;
}
